import { render, staticRenderFns } from "./stores.vue?vue&type=template&id=0230a367&"
import script from "./stores.vue?vue&type=script&lang=ts&"
export * from "./stores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0230a367')) {
      api.createRecord('0230a367', component.options)
    } else {
      api.reload('0230a367', component.options)
    }
    module.hot.accept("./stores.vue?vue&type=template&id=0230a367&", function () {
      api.rerender('0230a367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/stores/views/stores.vue"
export default component.exports